<template>
    <div class="snail-xihu">
        <!-- 活动标题 -->
        <div v-wechat-title="'寻宝！蜗的西湖之旅'"></div>
        <!-- 首页进入青瓷游戏LOGO -->
        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
            <div @touchmove.prevent class='preloading preloading-snail' v-show='preloadingShow'></div>
        </transition>

        <div class="content-box">
            <Header :isOnline="1" :config='headerConfig' />
            <div class="swiper-container content-swiper-container">
                <div class="swiper-wrapper" id="swiper-content">
                    <div class="swiper-slide swiper-slide-first">
                        <div class="first-travel-title"></div>
                        <div :class="['first-travel-box', overTime ? 'over' : '']">
                            <div class='btn-first-travel' @click="enterFirstTravel"></div>
                            <div :class="['btn-yinhua', miles_status === 1 ? 'tip' : '']" @click="enterMission"></div>
                            <div class="btn-book" @click="enterBook"></div>
                        </div>
                    </div>
                </div>
                <div class="content-button-prev"></div>
                <div class="content-button-next" @click="handleIndexNext"></div>
            </div>
        </div>

        <!-- 登录弹窗 -->
        <Login v-if='isShowLogin' noAuthLogin v-on:channelCallback='selectCallback' :gameName="gameName"
            :downloadUrl="downloadUrl" :loginTypes="loginTypes" channelTips="角色ID可在游戏中—蜗牛属性—蜗牛信息查看">
        </Login>
        <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell' :gameName="gameName">
        </Os>

        <!-- 引导对话框弹窗 -->
        <transition leave-active-class="animated fadeOut" name="fade">
            <div @touchmove.prevent class="guide-wrap popup_wrap" v-show="guideShow">
                <div class="btn-skip" @click="handleSkipClick"></div>
                <div class="dialog-text-box" v-show="dialogTextShow">
                    <p v-html="currentDialogText"></p>
                </div>
                <div class="guide-box" v-show="dialogShow">
                    <div v-if="dialogShow" class="dialog-box">
                        <h3>{{ guideRole }}</h3>
                        <p v-html="currentWord"></p>
                    </div>
                    <div class="role-chunJi">
                    </div>
                    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'
                        :duration="{ leave: 800 }">
                        <div class="choices-box" v-if="choicesShow">
                            <div class="first-choice" @click="onNextGuide(chunJiWords[currentWordIdx].btn1Key)">{{
                                chunJiWords[currentWordIdx].btn1Text }}</div>
                            <div class="second-choice" @click="onNextGuide(chunJiWords[currentWordIdx].btn2Key)">{{
                                chunJiWords[currentWordIdx].btn2Text }}</div>
                        </div>
                    </transition>
                </div>
                <transition enter-active-class="animated fadeIn" leave-active-class='animated fadeOut' name='fade'
                    :duration="{ leave: 800 }">
                    <div class="dialog-end-box" v-show="endShow">
                        <div class="end-label"></div>
                        <div :class="['end-title', endResult === 'redTea' ? 'redTea' : '']"></div>
                        <div class="end-tip">
                            <span>Man!</span>
                            <span>What can I say!</span>
                        </div>
                        <div class="dialog-box">
                            <p v-html="currentEndWord"></p>
                        </div>
                        <div v-if="dialogEnd" class="btn-skip-end" @click="handleSkipClick"></div>
                        <div v-if="dialogEnd" class="btn-reDialog" @click="handleReDialog"></div>
                    </div>
                </transition>
                <div class="close-bg" @click="closeDialogText"></div>
            </div>

        </transition>

        <!-- 展示首页 -->
        <transition :duration="{ enter: 100 }" enter-active-class='animated fadeIn'
            leave-active-class='animated fadeOut' name='fade'>
            <div @touchmove.prevent class="leading-wrap popup_wrap" v-show="leadingShow">
                <div class="title"></div>
                <div class="dialog-snail-text-box" v-show="snailDialogTextShow">
                    <p v-html="currentSnailDialogText"></p>
                </div>
                <div class="dialog-chunji-text-box" v-show="chunJiDialogTextShow">
                    <p v-html="currentChunJiDialogText"></p>
                </div>
                <div class="btn-start-travel" v-show="btnStartShow" @click="startTravel"></div>
            </div>
        </transition>

        <!-- 第一期结束后回顾确认弹窗 -->
        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
            <div class="first-end-confirm-wrap popup_wrap" v-show="firstEndConfirmModalShow">
                <div class="first-end-confirm-box">
                    <div class="btn-confirm" @click="handleLookBackClick"></div>
                </div>
                <div class="close-bg"></div>
            </div>
        </transition>
        <!-- 第一期弹窗 -->
        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
            <div class="firstTravel-wrap popup_wrap" v-show="firstTravelModalShow">
                <div class="firstTravel-content-box">
                    <div class="first-travel-title"></div>
                    <div :class="['qr-copy', 'monitor-btn', share ? 'got' : '']" @click="onCopy('index')"
                        id="clipboard-btn" data-event="复制链接" :data-clipboard-text="url"></div>
                    <div class="content-detail">
                        <div class="btn-play-intro" @click="showPlayWay"></div>
                        <div class="btn-show-activity" @click="showActivity"></div>
                        <div class="btn-show-info" @click="showInformation"></div>
                        <div class="btn-play" @click="showGame"></div>
                    </div>
                    <div class="btn-back" @click="handleFirstTravelBack"></div>
                </div>
            </div>
        </transition>
        <!-- 纪念册弹窗 -->
        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
            <div class="book-wrap popup_wrap" v-show="bookModalShow">
                <div class="book-content-box">
                    <div :class="['book-box']">
                        <div id="turnpage" class="turnpage">
                            <div class="book-cover">
                                <p class="os shadow"></p>
                                <p class="rid shadow"></p>
                            </div>
                            <div class="hard book-back">
                            </div>
                            <div :class="['sheet', 'page2', 'page3', join_periods[0] ? '' : 'grey']">
                                <div class="content"></div>
                                <div class="btn-prev" @click="prePage"></div>
                                <div class="btn-next" @click="nextPage"></div>
                            </div>
                            <div class="hard book-back" />
                            <div :class="['sheet', 'page4', 'page5', join_periods[1] ? '' : 'grey']">
                                <div class="content"></div>
                                <div class="btn-prev" @click="prePage"></div>
                                <div class="btn-next" @click="nextPage"></div>
                            </div>
                            <div class="hard book-back" />
                            <div :class="['sheet', 'page6', 'page7', join_periods[2] ? '' : 'grey']">
                                <div class="content"></div>
                                <div class="btn-prev" @click="prePage"></div>
                                <div class="btn-next" @click="nextPage"></div>
                            </div>
                            <div class="hard book-back" />
                        </div>
                    </div>
                    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'
                        :duration="1000">
                        <div v-show="btnOpenShow" class="btn-open-book" @click="openBook" />
                    </transition>
                    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'
                        :duration="1000">
                        <div v-show="btnShareShow" class="btn-share-book" @click="openShare" />
                    </transition>
                    <div class="btn-book-back" @click="closeBook" />
                </div>
                <div class="grey-bg"></div>
            </div>
        </transition>
        <!-- 景区资料弹窗 -->
        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
            <div class="information-wrap popup_wrap" v-show="informationModalShow">
                <div class="information-box">
                    <div class="information-content-box">
                        <div class="information-swiper-container swiper-no-swiping swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide slide1">
                                    <div class="info-img-box"></div>
                                    <div class="text-box">
                                        <div class="text-content">
                                            <p>西湖风景名胜区，是国务院首批公布的国家重点风景名胜区，也是国家AAAAA级旅游景区。西湖景区三面云山，中涵碧水，面积约60平方公里。2011年6月24日，“杭州西湖文化景观”成功列入世界遗产名录。西湖是中国历代文化精英秉承“天人合一”、“寄情山水”的中国山水美学理论下景观设计的杰出典范，展现了东方景观设计自南宋以来讲求“诗情画意”的艺术风格。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide slide2">
                                    <div class="info-img-box"></div>
                                    <div class="text-box">
                                        <div class="text-content">
                                            <p>西湖之美，美在如诗如画的湖光山色。环湖四周，绿荫环抱，山色葱茏，画桥烟柳，云树笼纱。100多处各具特色的公园景点中，有三秋桂子、六桥烟柳、九里云松、十里荷花，更有著名的“西湖十景”、“新西湖十景”、“三评西湖十景”，春夏秋冬各有景致，阴晴雨雪独有情韵。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide slide3">
                                    <div class="info-img-box"></div>
                                    <div class="text-box">
                                        <div class="text-content">
                                            <p>西湖之美，美在湖山与人文的浑然相融。西湖四周，古迹遍布，文物荟萃，近百处国家、省、市级重点文物保护单位镶嵌其中，为中国传衍至今的佛教文化、道教文化以及忠孝、隐逸、藏书、茶禅与印学等文化传统的发展与传承提供了见证，是我国著名的历史文化游览胜地。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-pagination information-pagination"></div>
                        </div>
                        <div class="swiper-button-prev information-button-prev"></div>
                        <div class="swiper-button-next information-button-next"></div>
                    </div>
                    <div class="btn-back" @click="handleInformationBack"></div>
                </div>
            </div>
        </transition>
        <!-- 福利活动列表弹窗 -->
        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
            <div class="activity-wrap popup_wrap" v-show="activityModalShow">
                <div class="activity-box">
                    <div class="activity-content-box">
                        <div class="activity-swiper-container swiper-no-swiping swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide slide1">
                                    <div class="info-img-box">
                                    </div>
                                    <div class="text-box">
                                        <p>行走在西湖，美景让蜗画意爆发！</p>
                                        <p>快来勾勒下湖中美景~</p>
                                    </div>
                                    <div class="btns-box">
                                        <div class="btn-enter-activity" @click="enterActivity('erchuang')"></div>
                                    </div>
                                </div>
                                <div class="swiper-slide slide2">
                                    <div class="info-img-box">
                                    </div>
                                    <div class="text-box">
                                        <p>西湖与文人墨客多有邂逅，</p>
                                        <p>一起来猜猜这些诗句，都是谁写下的吧~</p>
                                    </div>
                                    <div class="btns-box">
                                        <div class="btn-enter-activity" @click="enterActivity('huati')"></div>
                                    </div>
                                </div>
                                <div class="swiper-slide slide3">
                                    <div class="info-img-box">
                                    </div>
                                    <div class="text-box">
                                        <p>小姬和阿白还在公众号和TapTap</p>
                                        <p>准备了福利！快来看看吧！</p>
                                    </div>
                                    <div class="btns-box">
                                        <div class="btn-enter-activity" @click="enterActivity('tap')"></div>
                                        <div class="btn-left" @click="enterActivity('wechat')"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-pagination activity-pagination"></div>
                        </div>
                        <div class="swiper-button-prev activity-button-prev"></div>
                        <div class="swiper-button-next activity-button-next"></div>
                    </div>
                    <div class="btn-back" @click="handleActivityBack" />
                </div>
            </div>
        </transition>
        <!-- 玩法介绍弹窗 -->
        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
            <div class="play-way-intro-wrap popup_wrap" v-show="playWayIntroModalShow">
                <div class="play-way-box">
                    <div class="play-way-content-box">
                        <div class="play-way-swiper-container swiper-no-swiping swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide slide1">
                                    <div class="play-way-item-title">初夏西湖行</div>
                                    <div class="info-img-box"></div>
                                    <div class="text-box">
                                        <div class="text-content">
                                            <div class="time">活动时间：4月26日-5月10日</div>
                                            <p class="first-text">旋转骰子，初夏出行！蜗牛和小伙伴们再次踏上寻宝的旅程了，这次目的地是绿荫环抱的杭州西湖！</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide slide2">
                                    <div class="play-way-item-title">西湖拼图</div>
                                    <div class="info-img-box"></div>
                                    <div class="text-box">
                                        <div class="text-content">
                                            <p>三潭印月、雷锋夕照...西湖十景鹂听说过没~西湖美景如此娇艳，我要把景色都做成拼图，珍藏起来~</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide slide3">
                                    <div class="play-way-item-title">西湖翻花牌</div>
                                    <div class="info-img-box"></div>
                                    <div class="text-box">
                                        <div class="text-content">
                                            <p>听说西湖宝藏的秘密都隐藏在这小小的卡牌里？噢噢噢？！蜗居然开出了大奖，看来今天运气不错嘛~</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-pagination play-way-pagination"></div>
                        </div>
                        <div class="swiper-button-prev play-way-button-prev"></div>
                        <div class="swiper-button-next play-way-button-next"></div>
                    </div>
                    <div class="btn-play-way-reward" @click="appRewardShow = true" />
                    <div class="btn-back" @click="handlePlayWayBack" />
                </div>
            </div>
        </transition>
        <!-- APP内游戏奖励弹窗 -->
        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
            <div class="app-reward-wrap popup_wrap" v-show="appRewardShow">
                <div class="app-reward-box"></div>
                <div class="close-bg" @click="appRewardShow = false"></div>
            </div>
        </transition>
        <!-- 照片分享弹窗 -->
        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
            <div class="share-popup popup_wrap" v-show="shareShow">
                <div class="share-box popup_wrap-box">
                    <img src="../../../../assets/images/active/snail/riverMountain-3/bg_share_first.png"
                        class="share-img" v-if="isFirstShare">
                    <img src="../../../../assets/images/active/snail/riverMountain-3/bg_share_second.png"
                        class="share-img" v-else-if="isSecondShare">
                    <img src="../../../../assets/images/active/snail/riverMountain-3/bg_share_third.png"
                        class="share-img" v-else="isThirdShare">
                </div>
                <div class="share-tip">长按上方图片保存，快去分享给好友吧！</div>
                <div class="close-bg" @click="shareShow = false"></div>
            </div>
        </transition>
        <!-- 第三期游戏弹窗 -->
        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
            <div class="first-game-wrap popup_wrap" v-show="gameModalShow">
                <div class="first-game-box">
                    <div class="first-game-content-box">
                        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
                            <div class="index-box" v-show="showGameIndex">
                                <div class="btn-show-game-rule" @click="gameRuleShow = true"></div>
                                <div :class="['btn-game-reward', reward_list.includes(1) ? 'tip' : '']"
                                    @click="handleShowGameReward"></div>
                                <div class="btn-join-game" @click="handleJoinGame"></div>
                            </div>
                        </transition>
                        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
                            <div v-show="questionShow">
                                <div class="question-box" v-if="topic_list[topice_id]">
                                    <div class="question-title">{{ topic_list[topice_id].topic }}</div>
                                    <div class="question-options-box">
                                        <div v-for="(item, index) in optionList" :key="'option-' + index"
                                            :class="['question-option', choosedOption === index ? 'choosed' : '', isRight === 1 ? 'true' : isRight === 2 ? 'false' : '']"
                                            @click="answerQuestion(item.value, index)">
                                            {{ item.key }}. {{ topic_list[topice_id][item.value] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
                            <div class="game-reward-box" v-show="gameRewardShow">
                                <div class="red-tip-box">
                                    <div v-for="(item, index) in reward_list" :key="'status' + index"
                                        :class="['reward-item', `reward-${item}`, item === 1 ? 'tip' : '']"></div>
                                </div>
                                <div class="btn-share" @click="onCopy('game')" id="game-clipboard-btn" data-event="复制链接"
                                    :data-clipboard-text="url"></div>
                                <div :class="['reward-box', share ? 'got' : '']"></div>
                            </div>
                        </transition>
                    </div>
                    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
                        <div class="btn-get-reward" v-show="btnGetRewardShow" @click="handleGetAnswerReward"></div>
                    </transition>
                    <div class="btn-back" @click="handleGameBack"></div>
                </div>
            </div>
        </transition>
        <!-- 游戏规则弹窗 -->
        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
            <div class="game-rule-wrap popup_wrap" v-show="gameRuleShow">
                <div class="game-rule-box"></div>
                <div class="close-bg" @click="gameRuleShow = false"></div>
            </div>
        </transition>

        <!-- 里程碑和印花弹窗 -->
        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
            <div class="milestone-wrap popup_wrap" v-show="milesToneModalShow">
                <div class="milestone-box">
                    <div class="milestone-content-box">
                        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
                            <div class="total-mission-box">
                                <div class="yinzhang-box">
                                    <div v-for="(item, index) in milestoneProgress" :key="index"
                                        @click="handleMissionItemClick(index)"
                                        :class="['total-mission-item', `item-${index}`, item ? 'finished' : '', miles_status === 1 && index === 2 ? 'tip' : '']">
                                        <div class="img-item"></div>
                                        <div class="name">{{ milestoneProgressText[index] }}</div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                        <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut'>
                            <div class="mission-first-box" v-show="currentMissionShow">
                                <div class="yinhua-box">
                                    <div v-for="(item, index) in missionList[3]"
                                        :class="['mission-item-icon', `status${item.status}`]">
                                    </div>
                                </div>
                                <div class="milestone-first-mission-box">
                                    <div class="mission-item" v-for="(item, index) in missionList[3]"
                                        :key="'mission-' + index">
                                        <div class="mission-title">{{ item.name }}</div>
                                        <div :class="['mission-status', `status${item.status}`]"
                                            @click="handleMissionGetClick(item)"></div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                    <div class="btn-back" @click="handleMilestoneBack"></div>
                    <div class="grey-bg"></div>
                </div>
            </div>
        </transition>

        <!-- 阻止点击弹出-弹窗 -->
        <div @touchmove.prevent :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
    </div>
</template>
<script>
import { initUserinfo, getMilestone, initThirdTravelData, answer, getShareReward, getAnswerReward, getMissionReward } from '../api'
import { mapState, mapMutations, mapActions } from 'vuex'
import { headerConfig } from '../../headerConfig'
import Header from '@/components/Header'
import Login from '@/components/login'
import Os from '@/components/os'
import { Indicator, Toast } from 'mint-ui'
import _ from 'lodash'
import turn from '@/assets/js/turn.js'
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import Clipboard from "clipboard";
import { analysisParams, getTimeStamp, buriedLogger } from "@/utils/utils";
export default {
    name: 'riverMountainIndex',
    components: {
        Header,
        Login,
        Os
    },
    data() {
        return {
            overTime: false,
            // 福利活动链接 待替换
            urlList: {
                erchuang: "https://l.taptap.cn/YfR1siu3?channel=rep-rep_9lmoywnfyow",
                huati: "https://l.taptap.cn/iknh45JS?channel=rep-rep_3ebfvvcumt0",
                wechat:
                    "https://h5.qingcigame.com/package/index.html?id=39&area=QC-GAME",
                tap: "https://l.taptap.cn/QAE8fX9L?channel=rep-rep_vxubpvunme1_h5url1561"
            },
            preventShow: false,
            timer: null,
            url: '',
            timeList: {
                1: {
                    start: "2023/08/25 10:00:00",
                    end: "2023/09/08 23:59:59"
                },
                2: {
                    start: "2023/12/22 10:00:00",
                    end: "2024/01/05 23:59:59"
                },
                3: {
                    start: "2024/04/25 10:00:00",
                    end: "2024/05/10 23:59:59"
                }
            },
            isFirstShare: false,
            isSecondShare: false,
            isThirdShare: false,
            currentMissionShow: false, // 印花册进度条
            miles_status: 0, // 判断印花任务是否有可领取的
            milestoneProgressText: ["华山", "漠河", "西湖", "", ""],
            missionList: {},
            milestoneProgress: [],
            milesToneModalShow: false, // 里程碑弹窗
            answering: false, // 是否正在点击答案
            choosedOption: -1,
            isRight: 0, // 2表示错误，1表示正确，0表示初始
            questionShow: false, // 展示题目
            answer: 0, // 目前答对了几题
            is_red: false, // 奖励是否领取
            reward_list: [0, 0, 0, 0, 0], // 奖励列表1表示领了
            share: false, // 是否领取过分享奖励
            time: 0, // 答题次数
            topic_list: [], // 题目数组
            topice_id: 1, // 题目id
            user_activity: '',
            join_periods: [],
            gameName: 'snail',
            headerConfig,
            downloadUrl: 'https://static.qcplay.com/snail/official/',
            loginTypes: ['sms', 'password', 'channel'],
            user_activity: '',
            btnGetRewardShow: false, // 获取奖励按钮展示
            gameRewardShow: false, // 答题奖励
            gameRuleShow: false, // 活动规则弹窗
            showGameIndex: false, // 展示游戏框底图
            gameModalShow: false, // 第一期游戏弹窗
            shareShow: false, // 分享照片弹窗
            appRewardShow: false, // 游戏内奖励弹窗
            playWayIntroModalShow: false, // 玩法介绍弹窗
            activityModalShow: false, // 福利活动弹窗
            informationModalShow: false, // 景区资料
            btnOpenShow: true,
            btnShareShow: false,
            bookModalShow: false, // 纪念册弹窗
            firstTravelModalShow: false, // 旅游第一期弹窗
            firstEndConfirmModalShow: false, // 第一期结束后回顾确认弹窗
            indexSwiper: null,
            btnStartShow: false,
            currentSnailDialogText: '',
            currentChunJiDialogText: '',
            snailDialogTextShow: false,
            chunJiDialogTextShow: false,
            snailText: '那么，我们去哪......', // 首页蜗牛文字
            chunJiText: '这次要去西湖玩咯!', // 首页春姬文字
            leadingShow: false, // 展示首页
            dialogEnd: false, // 结局最后文字打印结束对话结束
            currentEndWord: '', // 结局的文字
            endResult: 'redTea', // 冰红茶蜗蜗的图片
            endShow: false, // 展示结局
            clickNextGuide: false, // 未点击选项
            guideRole: '春姬',
            currentWord: '', // 剧情人物的话
            currentWordIdx: 'first', // 剧情1的选择对话
            preloadingShow: true, // 进入动画
            guideShow: false, // 对话
            dialogTextShow: false,
            dialogShow: false, // 剧情1的春姬说的话
            dialoging: false, // 正在对话中
            choicesShow: false, // 是否要显示选项
            dialogText: '某天夜里A坐在庭院里观赏明月的蜗A在回味漠河之旅的时候A突然听到一阵快速的脚步声A...',
            currentDialogText: '',
            chunJiWords: {
                // 剧情1
                first: {
                    text: '嚯，蜗牛！吃我一招力劈华山，再接一招侧身冲拳!',
                    btn1Text: '想不到力劈华山还有招冲拳，小弟甘拜下风',
                    btn2Text: '这起势和收势...莫非是杭州的武林活拳?',
                    btn1Key: 'attack',
                    btn2Key: 'attack'
                },
                attack: {
                    text: '于吉最近刚从杭州回来，教了我这套拳法，还不错吧!',
                    btn1Text: '看来你是真想和蜗比划两下子',
                    btn2Text: '刚柔并济，不愧是小姬!',
                    btn1Key: 'travel',
                    btn2Key: 'travel'
                },
                travel: {
                    text: '说的我都想去杭州再修炼一下了！然后再去趟西湖，品一品西湖龙井!',
                    btn1Text: '那边的雪水云绿茶据说也很不错哦~',
                    btn2Text: '不要，冰红茶才是蜗的最爱!',
                    btn1Key: 'drink',
                    btn2Key: 'end'
                },
                drink: {
                    text: '穿上杭州的丝绸，拿上西湖绸伞在湖边漫步！小姬已经迫不及待出发了!',
                    btn1Text: '假期游客辣么多，确实得要"慢"步...',
                    btn2Text: '然后再去吃顿西湖醋鱼和龙井虾仁，太爽了...',
                    btn1Key: 'index',
                    btn2Key: 'index'
                },
                end: {
                    text: '诶...就小姬一个人去西湖,A真的假的...'
                }
            },
            optionList: [
                {
                    key: 'A',
                    value: 'answer_a'
                },
                {
                    key: 'B',
                    value: 'answer_b'
                },
                {
                    key: 'C',
                    value: 'answer_c'
                },
                {
                    key: 'D',
                    value: 'answer_d'
                },
            ]
        }
    },
    created() {
    },
    mounted() {
        const fitWidth = window.innerWidth;
        const fitHeight = window.innerHeight;
        const screenScale = Number((fitWidth / fitHeight).toFixed(3));
        console.log("scale", screenScale);
        const showTime = this.timeList[3].end;
        if (new Date(showTime).getTime() < new Date().getTime()) {
            this.overTime = true
        }
        // alert(screenScale)
        if (screenScale > 0.73) {
            this.bookClass = "scale-06";
        } else if (screenScale > 0.67) {
            this.bookClass = "scale-075";
        } else if (screenScale > 0.6) {
            this.bookClass = "scale-085";
        } else if (screenScale > 0.54) {
            // $('.container').addClass('scale-09');
        }

        this.url = `福利|最强蜗牛华夏寻宝之旅——西湖站启程！限定头像等你拿！https://h5.qingcigame.com/snail/riverMountain-3/enter${getTimeStamp()}`;
        this.shareLink = `https://h5.qingcigame.com/snail/riverMountain-3/enter${getTimeStamp()}`;
        this.$nextTick(() => {
            this.getLoginContainer()
            this.initFlipBook()
            this.isSetShare()
            this.initContentBoxSwiper()
            this.initInformationSwiper()
            this.initActivitySwiper()
            this.initPlayWaySwiper()
            // 埋点
            const bl = buriedLogger("snail", "riverMountain_page");
            this.logger = bl;
            setTimeout(() => {
                this.preloadingShow = false
                this.startDialog()
                this.logger.sum("蜗牛全国巡游主题h5_第三期活动页统计");
            }, 500)
        })
    },
    methods: {
        enterActivity(key) { // 还没弄
            const showTime = this.timeList[3].start;
            if (new Date(showTime).getTime() > new Date().getTime()) {
                this.myToast("活动尚未开启，预计于4月25日后开启");
                return;
            }
            const end = this.timeList[3].end;
            if (key === "wechat" && new Date(end).getTime() < new Date().getTime()) {
                this.myToast("活动已结束，感谢参与！");
                return;
            }
            this.logger.sum(`蜗牛全国巡游主题h5第三期_${key}`);
            setTimeout(() => {
                window.location.href = this.urlList[key];
            }, 300);
        },
        // 领取印花任务奖励
        handleMissionGetClick: _.throttle(
            function (item) {
                const { status, id } = item;
                if (status === 2 || status === 0) return;
                Indicator.open();
                getMissionReward({ task_id: id, periods: 3 })
                    .then(res => {
                        Indicator.close();
                        if (res.code === 200) {
                            this.initMilestone();
                        } else {
                            this.myToast(res.message);
                        }
                    })
                    .catch(err => {
                        Indicator.close();
                        this.myToast("服务器出错啦");
                    });
            },
            1000,
            { trailing: false }
        ),
        handleMilestoneBack() {
            if (this.currentMissionShow) {
                this.currentMissionShow = false
                return
            }
            this.milesToneModalShow = false
        },
        osCancell() {
            console.log("注销");
            this.milestoneProgress = [0, 0, 0, 0, 0];
            this.miles_status = 0;
            const missionList = this.missionList[3] || [];
            this.missionList = {
                1: missionList.map(item => ({ ...item, status: 0 })),
                2: missionList.map(item => ({ ...item, status: 0 })),
                3: missionList.map(item => ({ ...item, status: 0 }))
            };
            this.answer = 0;
            this.is_red = false;
            this.reward_list = [0, 0, 0, 0, 0];
            this.share = false;
            this.time = 0;
            this.topic_list = [];
            this.topice_id = 1;
            this.join_periods = [];
            $("#turnpage").turn("page", 1);
        },
        // 选择角色后
        selectCallback() {
            this.getLoginContainer();
        },
        handleIndexNext() {
            console.log("---", this.indexSwiper);
            this.indexSwiper && this.indexSwiper.slideNext();
        },
        preventClick() {
            this.preventShow = true;
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.preventShow = false;
            }, 1000);
        },
        // 微信分享
        isSetShare() {
            this.setShare({
                link: `https://h5.qingcigame.com/snail/riverMountain-3/enter${getTimeStamp()}`,
                title: '最强蜗牛华夏寻宝之旅启程！',
                imgUrl: 'https://download4.qcplay.com/qcgame-admin/JpiFxKySEHpq4p21jn34ArDmE8PrFXL5kxSVqoZF.png',
                desc: '华夏寻宝之旅启程了，与蜗一起走遍祖国大地，寻找隐藏的秘宝！'
            })
        },
        // 复制链接
        onCopy(place) {
            if (!this.userInfo.role_id) {
                this.myToast("请先登录", 1000);
                this.changeLoginPopup(true);
                return;
            }
            if (this.currentEndTip(3)) return;
            let clipboard = null;
            if (place === "index") clipboard = new Clipboard("#clipboard-btn");
            if (place === "game") clipboard = new Clipboard("#game-clipboard-btn");
            const text = place === "index" ? "联动页" : "游戏内页";
            this.logger.sum(`蜗牛全国巡游主题h5_第三期${text}分享`);
            clipboard.on("success", e => {
                // this.showShareModal = true
                this.myToast("已成功复制分享链接，快分享给好友们吧！");
                clipboard.destroy();
                if (this.share) return;
                getShareReward()
                    .then(res => {
                        if (res.code === 200 || res.code === 405) {
                            this.share = true;
                        }
                    })
                    .catch(() => {
                        this.myToast("服务器出错啦");
                    });
                e.clearSelection();
            });
            clipboard.on("error", e => {
                this.myToast("复制失败");
                clipboard.destroy();
            });
        },
        currentEndTip(index) {
            const showTime = this.timeList[index || 3].end;
            if (new Date(showTime).getTime() < new Date().getTime()) {
                this.myToast("活动已结束");
                return true;
            }
            return false;
        },
        handleMissionItemClick(index) {
            if (index === 0) {
                if (this.currentEndTip(1));
            } else if (index === 1) {
                if (this.currentEndTip(2));
            } else {
                this.currentMissionShow = true
            }
        },
        enterMission() {
            if (!this.userInfo.role_id) {
                this.myToast("请先登录", 1000);
                this.changeLoginPopup(true);
                return;
            }
            this.initMilestone()
            this.milesToneModalShow = true
            this.logger.sum("蜗牛全国巡游主题h5_第三期进入印章页");
        },
        // 初始化里程碑数据
        initMilestone() {
            getMilestone({ periods: 3 }).then((res) => {
                if (Number(res.code) == 200) {
                    this.milestoneProgress = res.data.milestone_schedule
                    this.missionList = res.data.current_schedule
                    this.miles_status = res.data.miles_status
                } else {
                    this.myToast(res.message)
                }
            }).catch(() => {
                this.myToast('服务器出错啦')
            })
        },
        handleGetAnswerReward() {
            if (!this.userInfo.role_id) {
                this.myToast("请先登录", 1000);
                this.changeLoginPopup(true);
                return;
            }
            if (this.currentEndTip(3)) return;
            const index = this.reward_list.findIndex(item => item === 1)
            if (index < 0) {
                this.myToast('当前暂无可领取奖励哦！')
                return
            }
            getAnswerReward({ periods: 3 }).then((res) => {
                if (res.code === 200) {
                    this.myToast('领取成功')
                    this.getThirdTravelData()
                }
            }).catch(() => {
                this.myToast('服务器出错啦')
            })
        },
        answerQuestion(option, index) {
            if (this.answering) return
            if (this.answer >= 5) {
                this.myToast('您已解锁所有答题奖励，请前往领取')
                return
            }
            if (this.time <= 0) {
                this.myToast('今天没次数了，明天再来吧')
                return
            }
            this.answering = true
            const params = {
                topic_id: this.topice_id,
                answer: option
            }
            Indicator.open()
            this.choosedOption = index
            answer({ ...params, periods: 3 }).then(res => {
                console.log('res', res)
                Indicator.close()
                if (res.code === 200) {
                    const { is_correct, key, score, time } = res.data
                    this.time = time
                    if (is_correct && this.answer >= 4) {
                        this.myToast('您已解锁所有答题奖励，请前往领取')
                        this.answer = this.answer + 1
                        this.isRight = 1
                        this.answering = false
                        return
                    }
                    if (is_correct) {
                        this.answer = this.answer + 1
                        this.isRight = 1
                    } else {
                        this.isRight = 2
                    }
                    this.time = time
                    setTimeout(() => {
                        this.topice_id = key
                        this.isRight = 0
                        this.choosedOption = -1
                        this.answering = false
                    }, 1000)
                } else {
                    this.answering = false
                    this.myToast(res.message)
                }
            }).catch((err) => {
                this.answering = false
                Indicator.close()
                this.myToast('服务器出错啦')
            })
        },
        handleJoinGame() {
            if (!this.userInfo.role_id) {
                this.myToast("请先登录", 1000);
                this.changeLoginPopup(true);
                return;
            }
            if (this.currentEndTip(3)) return;
            if (this.answer >= 5) {
                this.myToast("您已解锁所有答题奖励，请前往领取");
                return;
            }
            if (this.time <= 0) {
                this.myToast("今天没次数了，明天再来吧");
                return;
            }
            this.showGameIndex = false
            this.questionShow = true
        },
        getLoginContainer() {
            initUserinfo({ periods: 3 }).then(response => {
                if (Number(response.code) === 200) {
                    this.user_activity = response.data.activity
                    this.join_periods = response.data.activity.join_periods || []
                    this.onInitDataCallback(response)
                    this.initMilestone()
                    this.getThirdTravelData()
                    return
                }
                Number(response.code) !== 401 && this.myToast(response.message)
            }).catch((err) => {
                this.myToast('服务器出错啦')
            })
        },
        getRandomQuestion() {
            return Math.floor(Math.random() * 40 + 1)
        },
        getThirdTravelData() {
            initThirdTravelData({ periods: 3 }).then((res) => {
                if (res.code === 200) {
                    const { answer, is_red, reward_list, share, time, topic_list, topice_id } = res.data
                    this.answer = Number(answer) // 目前答对了几题
                    this.is_red = is_red // 奖励是否领取
                    this.reward_list = reward_list // 奖励列表
                    this.share = share // 是否领取过分享奖励
                    this.time = time // 答题次数
                    this.topic_list = topic_list // 题目数组
                    this.topice_id = topice_id === '0' ? this.getRandomQuestion() : Number(topice_id) // 题目id,0表示第一次答题
                } else if (res.code !== 401) {
                    this.myToast(res.message)
                }
            }).catch((err) => {
                this.myToast('服务器出错啦')
            })
        },
        // 游戏弹窗的返回按钮
        handleGameBack() {
            this.preventClick();
            if (this.questionShow) {
                this.questionShow = false
                this.showGameIndex = true
                this.choosedOption = -1
                this.isRight = 0
                this.getThirdTravelData()
                return
            }
            if (this.gameRewardShow) {
                this.gameRewardShow = false
                this.btnGetRewardShow = false
                this.showGameIndex = true
                return
            }
            this.gameModalShow = false
        },
        handleShowGameReward() {
            this.showGameIndex = false
            this.gameRewardShow = true
            this.btnGetRewardShow = true
        },
        showGame() {
            if (!this.userInfo.role_id) {
                this.myToast("请先登录", 1000);
                this.changeLoginPopup(true);
                return;
            }
            this.logger.sum("蜗牛全国巡游主题h5_第三期点击趣味游戏");
            this.gameModalShow = true
            this.showGameIndex = true
            this.questionShow = false
        },
        handlePlayWayBack() {
            this.playWayIntroModalShow = false
            this.preventClick()
        },
        // 展示玩法介绍
        showPlayWay() {
            this.playWayIntroModalShow = true
            this.logger.sum("蜗牛全国巡游主题h5_第三期点击玩法介绍");
        },
        // 展示活动列表
        showActivity() {
            this.activityModalShow = true
            this.logger.sum("蜗牛全国巡游主题h5_第三期点击福利活动");
        },
        // 福利活动返回按钮
        handleActivityBack() {
            this.activityModalShow = false
            this.preventClick()
        },
        // 景区资料返回按钮
        handleInformationBack() {
            this.informationModalShow = false
        },
        // 展示景区资料
        showInformation() {
            this.informationModalShow = true
            this.logger.sum("蜗牛全国巡游主题h5_第三期点击景区资料");
        },
        initPlayWaySwiper() {
            new Swiper('.play-way-swiper-container.swiper-container', {
                direction: 'horizontal',
                slidesPerView: 1,
                pagination: '.play-way-pagination.swiper-pagination',
                nextButton: '.play-way-button-next.swiper-button-next',
                prevButton: '.play-way-button-prev.swiper-button-prev',
                observer: true,
                observeParents: true,
            })
        },
        initInformationSwiper() {
            new Swiper('.information-swiper-container.swiper-container', {
                direction: 'horizontal',
                slidesPerView: 1,
                pagination: '.information-pagination.swiper-pagination',
                nextButton: '.information-button-next.swiper-button-next',
                prevButton: '.information-button-prev.swiper-button-prev',
                observer: true,
                observeParents: true,
            })
        },
        initActivitySwiper() {
            new Swiper('.activity-swiper-container.swiper-container', {
                direction: 'horizontal',
                slidesPerView: 1,
                pagination: '.activity-pagination.swiper-pagination',
                nextButton: '.activity-button-next.swiper-button-next',
                prevButton: '.activity-button-prev.swiper-button-prev',
                observer: true,
                observeParents: true,
            })
        },
        closeBook() {
            if ($('#turnpage').turn('page') === 1) {
                this.bookModalShow = false
            } else {
                $('#turnpage').turn('page', 1)
            }
        },
        myToast(text, time) {
            Toast({ message: text, className: "my-snail-tip", duration: time || 2000 })
        },
        // 打开书本
        openBook() {
            if (!this.userInfo.role_id) {
                this.myToast("请先登录", 1000);
                this.changeLoginPopup(true);
                return;
            }
            // 当前页面是1 所以可以nextPage
            if ($('#turnpage').turn('page') > 1) return
            this.nextPage()
            this.btnOpenShow = false
        },
        // 打开分享照片
        openShare: _.throttle(
            function () {
                this.shareShow = true
            },
            1000,
            { trailing: false }),
        prePage() {
            $('#turnpage').turn('previous')
        },
        nextPage() {
            if ($('#turnpage').turn('page') >= 6) {
                this.myToast('敬请期待')
                return
            }
            $('#turnpage').turn('next')
        },
        enterBook() {
            this.bookModalShow = true
            this.logger.sum("蜗牛全国巡游主题h5_第三期进入纪念册");
        },
        initFlipBook() {
            $('#turnpage').turn({
                elevation: 50,
                acceleration: true,
                display: 'double',
                page: 1,
                gradients: true, // Enable gradients
                duration: 1000,
                when: {
                    // 页面开始时
                    start: (e, pageConfig) => {
                        const { page, next } = pageConfig
                        if ((page === 2 && next === 1) || (page === 4 && next === 1) || (page === 6 && next === 1)) {
                            this.btnShareShow = false
                        }
                    },
                    // 翻页后触发
                    turned: (e, pageIndex) => {
                        if (pageIndex === 1) {
                            this.btnOpenShow = true
                        }
                        if (pageIndex == 2 || pageIndex === 3 || pageIndex === 4 || pageIndex === 5 || pageIndex === 6) {
                            this.btnShareShow = true // openBook中已将btnOpenShow置为false
                        }
                        if (pageIndex === 2 || pageIndex === 3) {
                            this.isFirstShare = true
                            this.isSecondShare = false
                            this.isThirdShare = false
                        } else if (pageIndex === 4 || pageIndex === 5) {
                            this.isFirstShare = false
                            this.isSecondShare = true
                            this.isThirdShare = false
                        } else if (pageIndex === 6) {
                            this.isFirstShare = false
                            this.isSecondShare = false
                            this.isThirdShare = true
                        }
                    },
                },
            })
        },
        handleFirstTravelBack() {
            this.firstTravelModalShow = false
            this.preventClick()
        },
        handleLookBackClick() {
            this.firstEndConfirmModalShow = false
            this.firstTravelModalShow = true
        },
        enterFirstTravel() {
            this.logger.sum("蜗牛全国巡游主题h5_进入第三期");
            const showTime = this.timeList[3].end;
            if (new Date(showTime).getTime() < new Date().getTime()) {
                this.firstEndConfirmModalShow = true
                return;
            }
            this.firstTravelModalShow = true;
        },
        startTravel() {
            this.leadingShow = false
            this.logger.sum("蜗牛全国巡游主题h5_第三期开始旅行");
            this.preventClick();
        },
        // 初始化首页内容swiper
        initContentBoxSwiper() {
            this.indexSwiper = new Swiper('.content-swiper-container.swiper-container', {
                direction: 'vertical',
                slidesPerView: 1,
                allowSwipeToPrev: false,
                allowSwipeToNext: false,
            })
        },
        // 打印蜗牛文字
        printSnailText() {
            const text = this.snailText
            const textArr = text.split('')
            const loop = () => {
                setTimeout(() => {
                    const str = textArr.shift(0, 1)
                    this.currentSnailDialogText += str
                    if (textArr.length !== 0) {
                        loop()
                    } else {
                        setTimeout(() => {
                            this.chunJiDialogTextShow = true
                            this.printChunJiText()
                        }, 300);
                    }
                }, 120)
            }
            loop()
        },
        // 打印春姬文字
        printChunJiText() {
            const text = this.chunJiText
            const textArr = text.split('')
            const loop = () => {
                setTimeout(() => {
                    const str = textArr.shift(0, 1)
                    this.currentChunJiDialogText += str
                    if (textArr.length !== 0) {
                        loop()
                    } else {
                        this.btnStartShow = true
                    }
                }, 120)
            }
            loop()
        },
        // 点击跳过剧情
        handleSkipClick() {
            // 如果不是第一次进入 guideShow 默认为false 所以要加入这段
            if (!this.guideShow) return
            this.guideShow = false
            localStorage.setItem('noShow', 1)
            this.startLeadingShow()
        },
        // 进入首页
        startLeadingShow() {
            this.leadingShow = true
            setTimeout(() => {
                this.snailDialogTextShow = true
                this.printSnailText()
            }, 300)
        },
        // 返回剧情3
        handleReDialog: _.throttle(function () {
            this.dialogEnd = false
            this.dialogShow = true
            this.endShow = false
            this.choicesShow = false
            this.currentWordIdx = 'travel'
            this.currentWord = this.chunJiWords[this.currentWordIdx].text
            setTimeout(() => {
                this.choicesShow = true
                this.clickNextGuide = true
                this.currentEndWord = ''
            }, 1500)
        }, 1000,
            {
                trailing: false
            }),
        // 下一段指导
        onNextGuide(key) {
            if (this.clickNextGuide === false) return
            this.logger.sum("蜗牛全国巡游主题h5_第三期点击对话");
            this.clickNextGuide = false
            this.choicesShow = false
            this.currentWord = ''
            this.currentWordIdx = key
            if (key === 'index') {
                // 去主页
                this.guideShow = false
                localStorage.setItem("noShow", 1);
                this.startLeadingShow()
                return
            } else if (key === 'end') {
                // 结局
                this.endShow = true
                this.dialogShow = false
                setTimeout(() => {
                    this.printEndText(this.chunJiWords[key].text)
                }, 1500)
                return
            }
            this.onPrint()
        },
        // 关闭首次的文字出现并开始引导动画
        closeDialogText() {
            if (this.dialoging || !this.dialogTextShow) return
            this.dialogTextShow = false
            this.startGuideAni()
        },
        // 开始引导动画
        startGuideAni: _.throttle(
            function () {
                this.clickNextGuide = false
                this.dialogShow = true
                this.currentWordIdx = 'first'
                this.currentWord = ''
                setTimeout(() => {
                    this.onPrint();
                }, 1700);
            }, 1000,
            {
                trailing: false
            }
        ),
        // 结局打印的文字方法
        printEndText(text) {
            const textArr = text.split('')
            const loop = () => {
                setTimeout(() => {
                    const str = textArr.shift(0, 1)
                    if (str === 'A') {
                        this.currentEndWord += `<br />`
                    } else {
                        this.currentEndWord += str
                    }
                    if (textArr.length !== 0) {
                        loop()
                    } else {
                        this.dialogEnd = true
                    }
                }, 120)
            }
            loop()
        },
        // 不是结局打印的文字方法 
        onPrint() {
            const text = this.chunJiWords[this.currentWordIdx].text || ''
            const textArr = text.split('')
            const loop = () => {
                setTimeout(() => {
                    const str = textArr.shift(0, 1)
                    this.joinWord(str)
                    if (textArr.length !== 0) {
                        loop()
                    } else {
                        this.clickNextGuide = true // 打印完某个剧情后就可以点击了
                        this.choicesShow = true // 选项展示
                    }
                }, 60)
            }
            loop()
        },
        // 组成文字
        joinWord(word) {
            if (word === 'A') {
                this.currentWord += `<br />`
            } else {
                this.currentWord += word
            }
        },
        // 首次文字出现
        startDialog() {
            if (localStorage.getItem("noShow")) {
                this.startLeadingShow()
                return;
            }
            this.logger.sum("蜗牛全国巡游主题h5_第三期进入前导页");
            this.guideShow = true
            this.dialogTextShow = true
            this.dialoging = true
            setTimeout(() => {
                this.autoPrint()
            }, 500)
        },
        // 自动打印文字
        autoPrint() {
            const text = this.dialogText
            const textArr = text.split('')
            const loop = () => {
                setTimeout(() => {
                    const str = textArr.shift(0, 1)
                    console.log('str', str)
                    if (str === 'A') {
                        this.currentDialogText += `<br />`
                    } else {
                        this.currentDialogText += str
                    }
                    if (textArr.length !== 0) {
                        loop()
                    } else {
                        setTimeout(() => {
                            this.dialoging = false;
                        }, 500);
                    }
                }, 80)
            }
            loop()
        },
        ...mapMutations([
            'changeLoginPopup',
            'changeOsPopup',
            'setLogger'
        ]),
        ...mapActions([
            'onInitDataCallback',
            'setShare'
        ])
    },
    computed: {
        ...mapState([
            'userInfo',
            'activeInfo',
            'isShowLogin',
            'isShowOs'
        ])
    },
    watch: {
        userInfo: {
            handler(newValue, oldValue) {
                console.log('newValue', newValue)
                console.log('oldValue', oldValue)
                if (!newValue.role_id) {
                    // TAG: 注销的时候
                    console.log('注销的时候')
                    this.osCancell()
                } else if (
                    newValue.role_id !== oldValue.role_id ||
                    newValue.account !== oldValue.account
                ) {
                    // 数据初始化
                    // this.getLoginContainer()
                }
            }
        },
    }
};
</script>

<style lang='less' scoped>
@import url('./index.less');
</style>


// WEBPACK FOOTER //
// src/pages/snail/xihu-3/index/index.vue